import { j as m } from "../../../jsx-runtime-B6kdoens.js";
import { c as i } from "../../../index-CROKJrb5.js";
import { c as l, f as p } from "../../../create-component-CBAeEoQ6.js";
import { useTabsState as u } from "../TabsState/index.js";
import { u as f } from "../../../react-B_GApDuV.js";
const b = i({
  base: ""
}), j = l(
  "TabContent",
  p(
    ({ as: e, className: o, value: a, ...s }, r) => {
      const n = e || "div", { activeAtom: c } = u(), t = f(c) === a;
      return t ? /* @__PURE__ */ m.jsx(
        n,
        {
          ref: r,
          className: b({
            className: o
          }),
          role: "tabpanel",
          "aria-selected": t,
          ...s
        }
      ) : null;
    }
  )
);
export {
  j as TabContent
};
//# sourceMappingURL=index.js.map
